/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import { Layout, Row, Col, Switch } from "antd";
import { HeartFilled, DesktopOutlined, MobileOutlined } from "@ant-design/icons";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const [isDesktopView, setIsDesktopView] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 모바일 기기 확인
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    // 로컬 스토리지에서 데스크톱 뷰 설정 불러오기
    const savedView = localStorage.getItem('desktopView');
    if (savedView === 'true') {
      setIsDesktopView(true);
      enableDesktopView();
    }

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const enableDesktopView = () => {
    // viewport meta 태그 변경
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute('content', 'width=1200');
    }
  };

  const enableMobileView = () => {
    // viewport meta 태그 복원
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }
  };

  const handleViewToggle = (checked) => {
    setIsDesktopView(checked);
    localStorage.setItem('desktopView', checked.toString());
    
    if (checked) {
      enableDesktopView();
    } else {
      enableMobileView();
    }

    // 페이지 새로고침하여 레이아웃 적용
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just" gutter={[16, 16]}>
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © 2025, made with
            {<HeartFilled />} by
            <a href="#pablo" className="font-weight-bold" target="_blank" rel="noopener noreferrer">
              Goguma
            </a>
            for economic freedom.
          </div>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            {isMobile && (
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'flex-end',
                gap: '8px',
                padding: '8px 0'
              }}>
                <MobileOutlined style={{ fontSize: '16px', color: isDesktopView ? '#999' : '#1890ff' }} />
                <Switch 
                  checked={isDesktopView}
                  onChange={handleViewToggle}
                  checkedChildren="PC"
                  unCheckedChildren="모바일"
                />
                <DesktopOutlined style={{ fontSize: '16px', color: isDesktopView ? '#1890ff' : '#999' }} />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
